import { resolveImageUrl } from "./imageUrl";

export const LOGIN_CONTENT_STORAGE_KEY = "hrmsLoginContentSettings";
export const LOGIN_CONTENT_STORAGE_EVENT = "hrms-login-content-settings-updated";

export const DEFAULT_LOGIN_CONTENT = {
  title: "",
  title2: "",
  quotes: "",
  logo: "",
};

export const getLoginContentSettings = () => {
  if (typeof window === "undefined") {
    return DEFAULT_LOGIN_CONTENT;
  }

  try {
    const rawValue = window.localStorage.getItem(LOGIN_CONTENT_STORAGE_KEY);
    if (!rawValue) {
      return DEFAULT_LOGIN_CONTENT;
    }

    const parsedValue = JSON.parse(rawValue);
    return {
      title: parsedValue?.title || DEFAULT_LOGIN_CONTENT.title,
      title2: parsedValue?.title2 || DEFAULT_LOGIN_CONTENT.title2,
      quotes: parsedValue?.quotes || DEFAULT_LOGIN_CONTENT.quotes,
      logo: resolveImageUrl(parsedValue?.logo || DEFAULT_LOGIN_CONTENT.logo),
    };
  } catch (error) {
    return DEFAULT_LOGIN_CONTENT;
  }
};

export const saveLoginContentSettings = (settings) => {
  const nextSettings = {
    title: settings?.title?.trim() || DEFAULT_LOGIN_CONTENT.title,
    title2: settings?.title2?.trim() || DEFAULT_LOGIN_CONTENT.title2,
    quotes: settings?.quotes?.trim() || DEFAULT_LOGIN_CONTENT.quotes,
    logo: resolveImageUrl(settings?.logo?.trim() || DEFAULT_LOGIN_CONTENT.logo),
  };

  if (typeof window !== "undefined") {
    window.localStorage.setItem(LOGIN_CONTENT_STORAGE_KEY, JSON.stringify(nextSettings));
    window.dispatchEvent(new CustomEvent(LOGIN_CONTENT_STORAGE_EVENT, { detail: nextSettings }));
  }

  return nextSettings;
};
